import React, {useState} from 'react';
import 'dayjs/locale/ru'
import {Button, Divider, Modal, notification} from "antd";
import PartnerCreateForm from "./PartnerCreateForm";
import {PartnerCreateDTO} from "../../../types/partner/PartnerCreateDTO";
import {useCreatePartnerMutation} from "../../../store/api/PartnerApi";

const PartnerCreateButton = () => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [createPartner] = useCreatePartnerMutation()

    const onOpenHandler = () => setVisible(true)

    const onCloseHandler = () => setVisible(false)

    const onFinishHandler = async (dto: PartnerCreateDTO) => {
        setLoading(true)
        await createPartner(dto)
            .then(() => {
                notification.success({
                    message: 'Заведение успешно создано!',
                    duration: 5
                })
            })
            .catch(error => notification.error({
                message: `Ошибка ${error.status}`,
                description: error.data.message,
                duration: 5
            }))
        setVisible(false)
        setLoading(false)
    }

    return (
        <>
            <Button type={'primary'} onClick={onOpenHandler}>
                + Добавить заведение
            </Button>
            <Modal
                title="Добавить заведение"
                open={visible}
                onCancel={onCloseHandler}
                okText="Создать"
                destroyOnClose
                okButtonProps={{
                    disabled: loading,
                    form: "partner-create-form",
                    htmlType: "submit"
                }}
            >
                <Divider/>
                <PartnerCreateForm partner={undefined} onFinish={onFinishHandler}/>
            </Modal>
        </>
    );
}

export default PartnerCreateButton;